import React from 'react';
import '../less/abroad.less';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import questions_top_img from '../img/questions_top_img.png';

export default function template() {
  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="services-abroad-new">
      <div className="services-abroad-new__top">
        <div className="container">
          <div className="services-abroad-new__row">
            <h1 className="services-abroad-new__title">{this.l10n("SERVICES_ABROAD_NEW_TITLE")}</h1>
            <img src={questions_top_img} className="services-abroad-new__image" alt="services abroad image" />
          </div>
        </div>
      </div>
      <QuestionsAdminNew
        widget={questionsWidget}
        showAll
        loader={this.state.loader}
        questionTag={"h2"}
      />
    </div>
  );
}
